// store.js
import { createStore } from 'vuex';
import { getDoc, doc } from 'firebase/firestore/lite';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore/lite';

export default createStore({
  state: {
    userData: null
  },
  mutations: {
    setUserData(state, userData) {
      state.userData = userData;
    }
  },
  actions: {
    async fetchUserData({ commit }) {
      const auth = getAuth();
      const db = getFirestore();
      const user = auth.currentUser;
      if (user) {
        const userDoc = await getDoc(doc(db, 'users_vue', user.uid));
        if (userDoc.exists()) {
          commit('setUserData', userDoc.data());
        }
      }
    }
  },
  getters: {
    userData: (state) => state.userData
  }
});
